import axios from "common/configs/axiosConfigs";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

const Staff = () => {
  const companyId = JSON.parse(localStorage.getItem("user-auth")).company_id;

  const [properties, setProperties] = useState([]);

  const getProperties = async () => {
    try {
      const { data } = await axios.post("", {
        action: "getStaffList",
        companyId,
      });
      if (data?.success) {
        setProperties(data?.data);
      } else {
        toast.error(data?.error);
      }
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    getProperties();
  }, []);
  return (
    <section>
      <h4>
        Staff{" "}
        <span class="text-muted" style={{ fontSize: 16 }}>
          ({properties?.length})
        </span>
      </h4>
      <div className="row gy-3">
        {properties?.map((p) => (
          <div className="col-lg-3 col-md-6">
            <div className="card">
              <h6>{p?.name}</h6>
              <p>{p?.phone}</p>
              <span className="badge">{p?.role}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Staff;
